import { AllergenKind } from "./allergenkind";
import {UserSettings} from "./usersettings";
import { UserCustomisation } from "./userCustomisation";
import { CustomNutrientEditViewModel } from "../ViewModels/customNutrientEditViewModel";

class ProfileUpdate {
    public settingsUpdate: UserSettingsUpdate;
    public allergenUpdates: AllergenUpdate[];
    public customNutrientUpdates: CustomNutrientUpdate[];
    public userCustomisation: UserCustomisation;
}

class UserSettingsUpdate extends UserSettings {

}

class AllergenUpdate {
    public allergenId: number;
    public allergenKind: AllergenKind;
    public isDeleted: boolean;
    public isNew: boolean;
    public name: boolean;
}

class CustomNutrientUpdate {
    public nutrientId: number;
    public name: string;
    public isDeleted: boolean;
    public isNew: boolean;
}

export { ProfileUpdate, UserSettingsUpdate, AllergenUpdate };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/Models/profileupdate.ts